'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'chess-rook';
var width = 384;
var height = 512;
var aliases = [9820];
var unicode = 'f447';
var svgPathData = 'M384 192l-48 64 0 136 48 72 0 48-384 0 0-48 48-72 0-136-48-64 0-192 384 0 0 192zM16 468.8l0 27.2 352 0 0-27.2-45.9-68.8-260.2 0-45.9 68.8zm0-282.2l48 64 0 133.3 256 0 0-133.3 48-64 0-170.7-104 0 0 72-16 0 0-72-112 0 0 72-16 0 0-72-104 0 0 170.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessRook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;